import type { ReactNode } from 'react';
import type { Me } from '../api/types';
import { HotelLogo } from './HotelLogo';

/** The top-left of every receipt and invoice: logo, hotel name, contacts, and the tax and business registration numbers. */
export function ReceiptBrand({ property, subtitle, showEmail = true }: { property: Me['property'] | undefined; subtitle?: ReactNode; showEmail?: boolean }) {
  const p = property;
  return (
    <div className="receipt-brand">
      <HotelLogo version={p ? p.logoVersion : undefined} className="receipt-logo" />
      <div>
        <h1 className="receipt-hotel">{p?.name ?? 'AA CountrySide Hotel'}</h1>
        {subtitle ? <div>{subtitle}</div> : null}
        {p?.address ? <div>{p.address}</div> : null}
        {p?.phone ? <div>Tel {p.phone}</div> : null}
        {showEmail && p?.email ? <div>{p.email}</div> : null}
        {p?.taxNumber || p?.businessRegistration ? (
          <div className="receipt-ids">
            {p.taxNumber ? <span>Tax no. {p.taxNumber}</span> : null}
            {p.businessRegistration ? <span>Reg. {p.businessRegistration}</span> : null}
          </div>
        ) : null}
      </div>
    </div>
  );
}
